import React, { useContext } from 'react';
import { UserContext } from 'contexts/user/UserContext';
import ChatRedirect from './ChatRedirect';  // Discourse redirect
import ChatFullscreen from './ChatFullscreen';  // Stream Chat

const ChatRouter: React.FC = () => {
  const { currentUser } = useContext(UserContext);
  if (currentUser === null || currentUser === undefined) {
    return null;
  }

  // Admin: Discourse redirect | Non-admin: Stream Chat
  if (currentUser?.isAdmin) {
    return <ChatRedirect />;
  }

  return <ChatFullscreen />;
};

export default ChatRouter;
